import type { ReactNode } from "react";
import { TopBar } from "./TopBar";
import { BottomNav } from "../../shared/components/BottomNav";
import { ToastContainer, useToasts } from "../../shared/components/Toast";

interface ShellProps {
  children: ReactNode;
}

export function Shell({ children }: ShellProps) {
  const { toasts, dismiss } = useToasts();

  return (
    <div className="shell">
      <TopBar />
      <main className="shell-main">{children}</main>
      <BottomNav />
      <ToastContainer toasts={toasts} onDismiss={dismiss} />
    </div>
  );
}

